var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"width":"1000","footer-hide":""}},[_c('Table',{attrs:{"border":"","columns":_vm.columns,"data":_vm.tableData,"no-data-text":"<div class='table-no-data'></div>","height":300},on:{"on-row-click":_vm.rowClick},scopedSlots:_vm._u([{key:"flowStatus",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('Tag',{attrs:{"color":_vm.flowStatus[row.ffstatus].color}},[_vm._v("\n                "+_vm._s(_vm.flowStatus[row.ffstatus].name))])]}},{key:"action",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('Button',{attrs:{"disabled":_vm.readonly,"type":"error","size":"small"},on:{"click":function($event){return _vm.del(row)}}},[_vm._v("撤回")])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b39275f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/diaodu/diaoduNew/diaoduHistory.vue
// module id = null
// module chunks = 